import { Stack, Typography } from '@mui/material';
import { Questionnaire } from 'features/lead/lead-management/lead-manage-questionnaires/lead-manage-questionnaires.types';
import PaiDotLoader from 'features/ui/base-components/pai-dot-loader';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import { useUserData } from 'hooks/use-user-data';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import QuestionnaireItem from './questionnaire-list-item';

interface Props {
  questionnairesLoading: boolean;
  questionnaires: Questionnaire[];
  searchFieldQuestionnaires: string;

  handleQuestionnaireSearchFieldChange(event: React.ChangeEvent<HTMLInputElement>): void;

  questionnaireSearchKeyUp(): void;

  searchKeyDown(): void;

  handleOpenConfirmDeleteQuestionnaireDialog(questionnaire: Questionnaire): () => void;

  handleOpenEditQuestionnaireDialog(questionnaire: Questionnaire): () => void;

  handleOpenMoveQuestionnaireDialog(questionnaire: Questionnaire): () => void;
}

const QuestionnaireList: React.FC<Props> = ({
  questionnairesLoading,
  questionnaires,
  searchFieldQuestionnaires,
  handleQuestionnaireSearchFieldChange,
  questionnaireSearchKeyUp,
  searchKeyDown,
  handleOpenConfirmDeleteQuestionnaireDialog,
  handleOpenEditQuestionnaireDialog,
  handleOpenMoveQuestionnaireDialog,
}) => {
  const { classes } = useStyles();
  const { token } = useUserData();

  return (
    <Stack className={classes.leadSurveysContent} gap={2}>
      <Stack className={classes.surveySearch}>
        <div style={{ maxWidth: '300px' }}>
          <PaiTextField
            label={'Suche'}
            placeholder={'Suche nach Umfragen'}
            value={searchFieldQuestionnaires}
            onChange={handleQuestionnaireSearchFieldChange}
            onKeyUp={questionnaireSearchKeyUp}
            onKeyDown={searchKeyDown}
            disableBorder={true}
          />
        </div>
      </Stack>

      {questionnairesLoading ? (
        <PaiDotLoader />
      ) : questionnaires.length > 0 ? (
        <Stack className={classes.leadSurveys} direction={'column'}>
          {questionnaires.map((questionnaire, index) => (
            <QuestionnaireItem
              key={questionnaire.id}
              questionnaire={questionnaire}
              isEven={index % 2 === 0}
              token={token}
              handleOpenConfirmDeleteQuestionnaireDialog={handleOpenConfirmDeleteQuestionnaireDialog}
              handleOpenEditQuestionnaireDialog={handleOpenEditQuestionnaireDialog}
              handleOpenMoveQuestionnaireDialog={handleOpenMoveQuestionnaireDialog}
            />
          ))}
        </Stack>
      ) : (
        <div className={classes.noSurveysRow}>
          <Typography className={classes.noSurveysText} align={'center'}>
            Der Ordner enthält keine Umfragen
          </Typography>
        </div>
      )}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  leadSurveysContent: {
    height: 'calc(100% - 19.5px - 32px)',
  },
  surveySearch: {
    width: '100%',
    padding: '16px',
    border: `2px solid ${theme.palette.backgrounds.main}`,
  },
  leadSurveys: {
    maxHeight: 'calc(100% - 16px - 66.5px)',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    overflow: 'auto',
  },
  noSurveysRow: {
    width: '100%',
    padding: '8px',
    minHeight: '36px',
    border: `2px solid ${theme.palette.backgrounds.main}`,
  },
  noSurveysText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
    padding: '0 4px',
  },
}));

export default QuestionnaireList;
